# TODO create test code
TermShowCtrl = ($scope, $location, TermService, term, AuthService) ->
  $scope.termBody = term.data.body

  $scope.accept = ->
    if AuthService.isSignedIn()
      TermService.accept()
    else
      TermService.acceptLocal(term.data.version)

TermShowCtrl.$inject = [
  '$scope'
  '$location'
  'TermService'
  'term'
  'AuthService'
]

module.exports = TermShowCtrl



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/term/show-controller.coffee